import type { ThemeOptions } from '@mui/material';

export function createAccordionStyles() {
  return {
    MuiAccordion: {
      styleOverrides: {
        root: ({ theme }) => ({
          '&:has(.Mui-focusVisible)::after': {
            content: '""',
            position: 'absolute',
            zIndex: 1,
            inset: 0,
            outline: `${theme.ui.focus.outlineWidth} solid ${theme.palette.action.focusOutline}`,
            outlineOffset: `${theme.ui.focus.outlineOffset}`,
            borderRadius: `${theme.ui.focus.borderRadius}`,
          },
          variants: [
            {
              props: (props) => !props['square'],
              style: {
                '&:first-of-type': {
                  borderTopLeftRadius: `${theme.shape.borderRadiusMd}px`,
                  borderTopRightRadius: `${theme.shape.borderRadiusMd}px`,
                },
                '&:last-of-type': {
                  borderBottomLeftRadius: `${theme.shape.borderRadiusMd}px`,
                  borderBottomRightRadius: `${theme.shape.borderRadiusMd}px`,
                },
              },
            },
          ],
        }),
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          '&.Mui-focusVisible': {
            background: 'none',
          },
        },
      },
    },
  } as ThemeOptions['components'];
}
